import KendaraanSelectorDialog from "../../../../dialogs/selectors/KendaraanSelectorDialog";
import TrailerSelectorDialog from "../../../../dialogs/selectors/TrailerSelectorDialog";
import PengecekanMobilOptionSelectorDialog from "../../../../dialogs/selectors/PengecekanMobilOptionSelectorDialog";

/**
 * The selector dialogs of the audit.
 *
 * kendaraanSelectorFilter: (config) which kendaraan can be picked (mobil: not Trado, trado: only Trado)
 */
const EditorSelectorDialogs = ({
  headerData,
  loading,
  kendaraanSelectorFilter,
  // marking option
  showPengecekanMobilOptionDialog,
  setShowPengecekanMobilOptionDialog,
  handleOnConfirmPengecekanMobilOption,
  optionSelectorAdditionalFilter,
  pengecekanMobilOptionDialogData,
  // kendaraan / trailer
  showKendaraanSelector,
  setShowKendaraanSelector,
  handleOnConfirmKendaraan,
  showTrailerSelector,
  setShowTrailerSelector,
  handleOnConfirmTrailer,
}) => {
  return (
    <>
      <PengecekanMobilOptionSelectorDialog
        title="Pilih Keterangan Marking"
        visible={showPengecekanMobilOptionDialog}
        onHide={() => setShowPengecekanMobilOptionDialog(false)}
        onConfirm={handleOnConfirmPengecekanMobilOption}
        loadings={loading}
        additionalFilter={optionSelectorAdditionalFilter}
        kendaraanJenisId={
          headerData.data_kendaraan &&
          headerData.data_kendaraan.kendaraan_jenis_id
            ? headerData.data_kendaraan.kendaraan_jenis_id
            : 0
        }
        labelGrup={
          pengecekanMobilOptionDialogData.label_grup
            ? pengecekanMobilOptionDialogData.label_grup
            : ""
        }
      />
      <KendaraanSelectorDialog
        title="Pilih Kendaraan"
        additionalFilter={kendaraanSelectorFilter}
        visible={showKendaraanSelector}
        onHide={() => setShowKendaraanSelector(false)}
        onConfirm={handleOnConfirmKendaraan}
      />
      <TrailerSelectorDialog
        title="Pilih Trailer"
        visible={showTrailerSelector}
        onHide={() => setShowTrailerSelector(false)}
        onConfirm={handleOnConfirmTrailer}
      />
    </>
  );
};

export default EditorSelectorDialogs;
